<template>
  <div class="view-wrapper">

    <div class="search-container elevation-1 white px-3 pt-2 pb-2 d-flex flex-column">
      
      <v-radio-group 
        v-model="tipoBusca" 
        row 
        hide-details 
        class="mt-0 mb-3" 
        @change="focarInputBusca"
      >
        <v-radio label="Código" value="codigo" color="primary"></v-radio>
        <v-radio label="Razão" value="razao" color="primary"></v-radio>
        <v-radio label="CNPJ/CPF" value="cnpj" color="primary"></v-radio>
        <v-radio label="Fantasia" value="fantasia" color="primary"></v-radio>
      </v-radio-group>

      <div class="d-flex align-center" style="width: 100%;">
        <v-text-field
          ref="campoBusca"
          v-model="termoBusca"
          :label="labelBusca"
          outlined
          dense
          clearable
          hide-details
          class="mr-2"
        ></v-text-field>

        <v-btn 
          height="40"
          width="70"
          min-width="40"
          class="px-2 mr-2"
          color="primary" 
          elevation="2" 
          @click="forcarBusca('inicio')"
          title="Buscar pelo Início"
        >
          <v-icon>mdi-arrow-left-thick</v-icon>
        </v-btn>

        <v-btn 
          height="40"
          width="70"
          min-width="40"
          class="px-2"
          color="primary" 
          elevation="2" 
          @click="forcarBusca('qualquer')"
          title="Buscar em Qualquer Parte"
        >
          <v-icon>mdi-arrow-left-thick</v-icon><v-icon>mdi-arrow-right-thick</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="content-container elevation-2">
      <v-card class="d-flex flex-column fill-height">
        
        <div v-if="loadingInicial" class="text-center pa-8 flex-grow-1">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <p class="mt-4 mb-0">Carregando fornecedores...</p>
        </div>

        <div v-else-if="!loadingInicial && resultados.length === 0" class="text-center pa-8 flex-grow-1">
          <p class="mb-0">Nenhum resultado encontrado.</p>
        </div>

        <RecycleScroller
          v-else
          ref="scrollerComponent" class="scroller"
          :items="resultados"
          :item-size="150" 
          key-field="foridnuvem"
          v-slot="{ item }"
        >
          <div class="list-item-wrapper" style="height: 150px; border-bottom: 1px solid #e0e0e0;">
            <v-list-item
              class="list resultado-item-clicavel px-2 fill-height"
              :class="{ 'item-selecionado': itemSelecionado === item }"
              @click="selecionarEVoltar(item)"
            >
              <!-- <v-list-item-action class="mr-2 align-self-center" @click.stop>
                <v-checkbox
                  :input-value="itemSelecionado === item"
                  @change="toggleSelecao(item)"
                  color="primary"
                ></v-checkbox>
              </v-list-item-action> -->
              
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium text-wrap text-justify" 
                  style="height: auto; line-height: 1.5rem; word-break: break-word;">
                  {{ item.foridnuvem }} - {{ item.fornome }}
                </v-list-item-title>

                <v-list-item-subtitle v-if="item.forfantasia">
                  {{ item.forfantasia }}
                </v-list-item-subtitle>

                <v-list-item-subtitle v-if="item.forendereco">
                  {{ item.forendereco }}
                </v-list-item-subtitle>

                <v-list-item-subtitle v-if="item.forcnpj_cpf">
                  {{ formatarCpfCnpj(item.forcnpj_cpf) }}
                </v-list-item-subtitle>

                <v-list-item-subtitle v-if="item.fortelefone">
                  Fone: {{ item.fortelefone }}
                </v-list-item-subtitle>

                <v-list-item-subtitle v-if="item.fortipo">
                  Tipo: {{ item.fortipo }}
                </v-list-item-subtitle>
              </v-list-item-content>

            </v-list-item>
          </div>
        </RecycleScroller>
      </v-card>
    </div>

  </div>
</template>

<script>
import Vue from 'vue';
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import db from '@/plugins/dexie';


Vue.use(VueVirtualScroller);

export default {
  name: 'ViewPesquisaFornecedor',

  data() {
    return {
      loadingInicial: true,
      itemSelecionado: null,
      resultados: [],
      
      currentSearchId: 0,
      
      termoBusca: this.$route.query.busca || '', 
      tipoBusca: this.$route.query.tipoBusca || 'razao', 
      modoBusca: this.$route.query.modoBusca || 'qualquer', 
    };
  },

  computed: {
    labelBusca() {
      switch (this.tipoBusca) {
        case 'codigo': return 'Buscar por Código';
        case 'cnpj': return 'Buscar por CNPJ ou CPF';
        case 'fantasia': return 'Buscar por Nome Fantasia';
        case 'razao':
        default: return 'Buscar por Razão Social';
      }
    }
  },

  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler(newQuery, oldQuery) {
        if (oldQuery) {
          const filtrosImportantes = ['codigopessoa', 'nome', 'cnpj', 'fantasia', 'cidade', 'tipo', 'busca', 'tipoBusca', 'modoBusca'];
          const mudouFiltro = filtrosImportantes.some(key => newQuery[key] !== oldQuery[key]);
          if (mudouFiltro) {
            sessionStorage.removeItem('listaFornecedoresScrollPos');
          }
        }

        if (!oldQuery) {
          this.iniciarProcesso();
          return;
        }
        
        // ADICIONE O 'tipo' AQUI TAMBÉM:
        const filtrosImportantes = ['codigopessoa', 'nome', 'cnpj', 'fantasia', 'cidade', 'tipo', 'busca', 'tipoBusca', 'modoBusca'];
        const mudouFiltro = filtrosImportantes.some(key => newQuery[key] !== oldQuery[key]);

        if (mudouFiltro || this.resultados.length === 0) {
          this.iniciarProcesso();
        } else {
          this.restaurarSelecaoDaUrl();
        }
      },
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.$refs.scrollerComponent && this.$refs.scrollerComponent.$el) {
      const scrollPos = this.$refs.scrollerComponent.$el.scrollTop;
      sessionStorage.setItem('listaFornecedoresScrollPos', scrollPos);
    }
    next();
  },

  methods: {
    focarInputBusca() {
      this.$nextTick(() => {
        if (this.$refs.campoBusca) {
          this.$refs.campoBusca.focus();
          
          const nativeInput = this.$refs.campoBusca.$el.querySelector('input');
          if (nativeInput) {
            nativeInput.select();
          }
        }
      });
    },

    removerAcentos(texto) {
      if (!texto) return '';
      return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    },

    forcarBusca(modoSelecionado = null) {
      if (modoSelecionado) {
        this.modoBusca = modoSelecionado;
      }
      
      const query = { ...this.$route.query };
      const buscaLimpa = this.termoBusca ? this.termoBusca.trim() : '';
      
      if (buscaLimpa !== '') {
        query.busca = buscaLimpa;
        query.modoBusca = this.modoBusca;
      } else {
        delete query.busca;
        delete query.modoBusca;
      }
      
      query.tipoBusca = this.tipoBusca;

      if (this.$route.query.busca !== query.busca || 
          this.$route.query.tipoBusca !== query.tipoBusca ||
          this.$route.query.modoBusca !== query.modoBusca) {
        this.$router.replace({ query }).catch(() => {});
      } else {
        this.iniciarProcesso();
      }
    },

    async iniciarProcesso() {
      this.currentSearchId = Date.now();
      this.resultados = [];
      this.itemSelecionado = null;
      this.loadingInicial = true;

      await this.carregarPaginaVisualizacao();

      this.loadingInicial = false; 
      this.restaurarPosicaoScroll();
    },

    restaurarPosicaoScroll() {
      const posSalva = sessionStorage.getItem('listaFornecedoresScrollPos');
      
      if (posSalva && this.resultados.length > 0) {
        setTimeout(() => {
          const scroller = this.$refs.scrollerComponent;
          if (scroller && scroller.$el) {
            scroller.$el.scrollTop = parseInt(posSalva);
          }
        }, 100); 
      }
    },

    async carregarPaginaVisualizacao() {
      const { codigopessoa, nome, cnpj, fantasia, cidade, tipo, busca, tipoBusca, modoBusca } = this.$route.query;

      try {
        const idBusca = codigopessoa ? parseInt(codigopessoa) : 0;
        const nomeBusca = nome ? nome.trim().toLowerCase() : null;
        const fantasiaBusca = fantasia ? fantasia.trim().toLowerCase() : null;
        const cidadeLower = cidade ? cidade.toLowerCase() : null;
        const cnpjLimpo = cnpj ? cnpj.replace(/\D/g, '') : null;
        
        const termoGlobal = busca ? busca.trim() : null;
        const tipoBuscaAtivo = tipoBusca || 'razao';
        const modoBuscaAtivo = modoBusca || 'qualquer';
        
        let collection;
        let jaEstaOrdenado = false;

        if (termoGlobal) {
          collection = db.fornecedor.orderBy('fornome');
          jaEstaOrdenado = true;
        } 
        else if (idBusca > 0) {
          collection = db.fornecedor.where('foridnuvem').equals(idBusca);
        } else if (nomeBusca && !fantasiaBusca) {
          collection = db.fornecedor.where('fornome').startsWithIgnoreCase(nomeBusca);
          jaEstaOrdenado = true;
        } else if (fantasiaBusca) {
          collection = db.fornecedor.where('forfantasia').startsWithIgnoreCase(fantasiaBusca);
        } else {
          collection = db.fornecedor.orderBy('fornome');
          jaEstaOrdenado = true;
        }

        collection = collection.filter(c => c.foridnuvem && c.fornome);

        let fornecedores = await collection.toArray();

        if (nomeBusca || fantasiaBusca || cnpjLimpo || cidadeLower || termoGlobal || tipo) {
          fornecedores = fornecedores.filter(c => {
            let match = true;

            if (nomeBusca && !c.fornome?.toLowerCase().includes(nomeBusca)) match = false;
            if (match && fantasiaBusca && !c.forfantasia?.toLowerCase().includes(fantasiaBusca)) match = false;
            if (match && cnpjLimpo) {
                const dbCnpj = c.forcnpj_cpf ? c.forcnpj_cpf.replace(/\D/g, '') : '';
                if (!dbCnpj.includes(cnpjLimpo)) match = false;
            }
            if (match && cidadeLower) {
                if (!c.forendereco || !c.forendereco.toLowerCase().includes(cidadeLower)) match = false;
            }

            // NOVA REGRA DE TIPO AQUI:
            if (match && tipo && tipo.toUpperCase() !== 'TODOS') {
                if (!c.fortipo || c.fortipo.toUpperCase() !== tipo.toUpperCase()) match = false;
            }

            if (match && termoGlobal) {
                const termoAcento = this.removerAcentos(termoGlobal.toLowerCase());
                
                if (tipoBuscaAtivo === 'razao') {
                    const desc = c.fornome ? this.removerAcentos(c.fornome.toLowerCase()) : '';
                    if (modoBuscaAtivo === 'inicio') {
                      if (!desc.startsWith(termoAcento)) match = false;
                    } else {
                      if (!desc.includes(termoAcento)) match = false;
                    }
                } 
                else if (tipoBuscaAtivo === 'codigo') {
                    const cod = c.foridnuvem ? c.foridnuvem.toString() : '';
                    if (modoBuscaAtivo === 'inicio') {
                      if (!cod.startsWith(termoGlobal)) match = false;
                    } else {
                      if (!cod.includes(termoGlobal)) match = false;
                    }
                } 
                else if (tipoBuscaAtivo === 'fantasia') {
                    const fant = c.forfantasia ? this.removerAcentos(c.forfantasia.toLowerCase()) : '';
                    if (modoBuscaAtivo === 'inicio') {
                      if (!fant.startsWith(termoAcento)) match = false;
                    } else {
                      if (!fant.includes(termoAcento)) match = false;
                    }
                } 
                else if (tipoBuscaAtivo === 'cnpj') {
                    const termoCnpjLimpo = termoGlobal.replace(/\D/g, '');
                    const dbCnpj = c.forcnpj_cpf ? c.forcnpj_cpf.replace(/\D/g, '') : '';
                    if (modoBuscaAtivo === 'inicio') {
                      if (!dbCnpj.startsWith(termoCnpjLimpo)) match = false;
                    } else {
                      if (!dbCnpj.includes(termoCnpjLimpo)) match = false;
                    }
                }
            }

            return match;
          });
        }

        if (!jaEstaOrdenado && fornecedores.length > 0) {
          fornecedores.sort((a, b) => {
            const nomeA = (a.fornome || '').trim();
            const nomeB = (b.fornome || '').trim();
            return nomeA.localeCompare(nomeB, 'pt-BR', { sensitivity: 'base' });
          });
        }

        this.resultados = fornecedores;
        this.restaurarSelecaoDaUrl();
        return true;

      } catch (error) {
        console.error("Erro na busca local:", error);
        return false;
      }
    },

    restaurarSelecaoDaUrl() {
      const { selecionadoId } = this.$route.query;
      if (selecionadoId && this.resultados.length > 0) {
        const idParaSelecionar = parseInt(selecionadoId);
        const itemEncontrado = this.resultados.find(r => r.foridnuvem === idParaSelecionar);
        if (itemEncontrado) this.itemSelecionado = itemEncontrado;
      }
    },

    toggleSelecao(item) {
      const novoItem = (this.itemSelecionado === item) ? null : item;
      this.itemSelecionado = novoItem;
      const query = { ...this.$route.query };
      
      if (novoItem) {
        query.selecionadoId = novoItem.foridnuvem;
      } else {
        delete query.selecionadoId;
      }
      this.$router.replace({ query }).catch(() => {});
    },

    formatarCpfCnpj(valor) {
      if (!valor) return '';
      const digitos = valor.replace(/\D/g, '');
      if (digitos.length === 11) return digitos.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      if (digitos.length === 14) return digitos.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      return valor;
    },

    selecionarEVoltar(item) {
      if (!item) return;
      this.finalizarSelecao(item);
    },

    finalizarSelecao(item) {
      sessionStorage.setItem('pesquisaResultado', JSON.stringify({ 
        tipo: 'Fornecedor', 
        codigo: item.foridnuvem,
        descricao: item.fornome 
      }));
      this.$router.back();
    },

    voltar() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.view-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 56px);
}
.content-container {
  width: 100%;
  flex-grow: 1;
  overflow: hidden;
}
.item-selecionado {
  background-color: #E3F2FD !important;
}
.scroller {
  height: 100%;
  overflow-y: auto;
}
.scroller::-webkit-scrollbar {
  width: 12px;
}
.scroller::-webkit-scrollbar-thumb {
  background: rgba(76, 111, 175, 0.4);
  border-radius: 4px;
}
.scroller::-webkit-scrollbar-thumb:hover {
  background-color: #ccc;
}
.list{
  background-color: white;
}
::v-deep .v-input--radio-group__input {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
::v-deep .v-radio {
  margin-right: 0px !important;
}
</style>